import { typedAction } from "../helpers";
import { dataSourceState } from "../models/reduxModels"
import { SET_DATASOURCE } from "./actionTypes";

const initialState: dataSourceState = { values: {}, initialLoad: false };

export const setDatasourceValues = (values: any, initialLoad?: boolean, callerId?: number) => {
    return typedAction(SET_DATASOURCE, { values, initialLoad, callerId });
};

type DataSourceAction = ReturnType<typeof setDatasourceValues>;

export function datasourceReducer(
    state = initialState,
    action: DataSourceAction
): dataSourceState {
    switch (action.type) {
        case SET_DATASOURCE:
            return { ...state, values: action.payload.values, initialLoad: action.payload.initialLoad === true, callerId: action.payload.callerId };
        default:
            return state;
    }
}